import { isString } from "../../validate"
import { charsForStartForbid, containsEmoji, containsFullwidthAlphanum } from "./specialChecking"

export default ({ value: str }) => {
  if (!isString(str)) return false

  const maxEmailLength = 50
  if (str.length <= 0 || str.length > maxEmailLength) return false

  if (containsEmoji(str)) return false
  if (containsFullwidthAlphanum(str)) return false

  if (str.slice(0, 1).match(charsForStartForbid)) return false

  if (str.charAt(0) === "." || str.charAt(str.length - 1) === ".") return false

  const notOneDot = /(\.\.)/.test(str)
  if (notOneDot) return false
  const hasChineseChars = /[\u4E00-\u9FFF]/.test(str)
  if (hasChineseChars) return false

  const parts = str.split("@")
  if (parts.length < 2) return false

  const validEmailFormat = /^([a-zA-Z0-9\.\-\_\+]{1,})@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(str)
  if (!validEmailFormat) return false

  return true
}
